import LegalLayout, { H2, UL } from "@/components/layout/LegalLayout";

export default function DPA() {
  return (
    <LegalLayout titleKey="dpa" title="Data Processing Addendum (DPA)" testId="legal-dpa-page">
      <H2>Purpose</H2>
      <p>This Data Processing Addendum governs processing of personal data by AtlasForge Financial on behalf of business customers using our APIs and enterprise services.</p>

      <H2>Definitions</H2>
      <p><strong>Controller:</strong> Entity determining purposes of processing.</p>
      <p><strong>Processor:</strong> Entity processing data on behalf of a Controller.</p>
      <p><strong>Personal Data:</strong> Information relating to an identified or identifiable individual.</p>

      <H2>Processing Activities</H2>
      <p>AtlasForge may process personal data solely to:</p>
      <UL items={["Provide contracted services", "Maintain infrastructure", "Support customers", "Ensure security", "Meet legal obligations"]} />

      <H2>Security Measures</H2>
      <p>AtlasForge maintains reasonable administrative, technical, and organizational safeguards, including:</p>
      <UL items={["Encryption", "Access controls", "Monitoring", "Incident response procedures"]} />

      <H2>Subprocessors</H2>
      <p>AtlasForge may utilize trusted subprocessors, including:</p>
      <UL items={["Cloud infrastructure providers", "Payment processors", "Banking connectivity providers", "Analytics providers"]} />

      <H2>International Transfers</H2>
      <p>Where applicable, AtlasForge implements appropriate safeguards for international transfers of personal data.</p>

      <H2>Data Subject Rights</H2>
      <p>AtlasForge will assist customers in responding to requests involving:</p>
      <UL items={["Access", "Correction", "Deletion", "Portability", "Restriction of processing"]} />

      <H2>Security Incidents</H2>
      <p>AtlasForge will notify affected customers of confirmed security incidents involving personal data without unreasonable delay.</p>

      <H2>Contact</H2>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
